import { UseFormReturn } from 'react-hook-form'
import showErrorToast from '@/common/utils/showErrorToast'
import { FormValues } from '../components/MemberForm'

export const handleMemberFormError = (
	error: any,
	form: UseFormReturn<FormValues>,
	mode: 'create' | 'edit',
) => {
	const errorMessage = error?.response?.data?.message

	if (Array.isArray(errorMessage)) {
		errorMessage.forEach((message) => {
			if (message.includes('phone must be a valid phone number')) {
				form.setError('phone', {
					message: 'กรุณากรอกเบอร์โทรศัพท์ที่ถูกต้อง',
				})
			}
		})
		return
	}

	if (errorMessage === 'DUPLICATE_USERNAME') {
		form.setError('username', {
			message: 'ชื่อผู้ใช้งานนี้มีการใช้งานแล้ว',
		})
		return
	}

	showErrorToast(
		mode === 'create' ? 'สร้างผู้ใช้งานไม่สำเร็จ' : 'แก้ไขผู้ใช้งานไม่สำเร็จ',
	)
}
